import { localStorageItemNames } from "../constants";
import { PageNameConstant } from "../constants/PageNameConstant";

export const onSortChanged = async (
  gridRef,
  setSortedColumn,
  setColumnFinal,
  columnFinal,
  sortableColumnData,
  createSortableColumn,
  updateViewSortableColumn,
  pageName
) => {
  if (!gridRef.current) return;

  // Get sorted columns
  const sortedColumns = gridRef.current.columnApi
    .getColumnState()
    .filter((col) => col.sort);
  if (sortedColumns.length === 0) {
    columnFinal.map((item) => (item.sort = null));
    setColumnFinal(columnFinal);
    setSortedColumn([]);
  }
  let columnId;
  let sortingDirection;
  let sortingRowData = [];
  const sortedRows = [];
  sortedColumns.forEach(({ colId, sort }) => {
    columnId = colId;
    sortingDirection = sort;
    // Get sorted row data for the sorted column

    const rowCount = gridRef.current.api.getDisplayedRowCount();

    for (let i = 0; i < rowCount; i++) {
      const rowNode = gridRef.current.api.getDisplayedRowAtIndex(i);
      if (rowNode) {
        sortedRows.push(rowNode.data["fleetNo"]); // Get only the sorted column values
      }
    }
    setSortedColumn(sortedRows);
    setColumnFinal((prevDefs) => {
      // Reset sorting for all columns first
      const updatedDefs = prevDefs.map((col) => ({
        ...col,
        sort: null,
        headerName: col.headerName, // Reset header name
        colId: col.field,
      }));

      // Apply sorting only to the newly sorted column(s)
      sortedColumns.forEach(({ colId, sort }) => {
        const colIndex = updatedDefs.findIndex((col) => col.field === colId);
        if (colIndex !== -1) {
          updatedDefs[colIndex] = {
            ...updatedDefs[colIndex],
            sort: sort,
            headerName: `${updatedDefs[colIndex].headerName}`,
          };
        }
      });
      return updatedDefs;
    });
  });

  if (sortedColumns?.length > 0 || sortedColumns?.length === 0) {
    if (sortableColumnData?.length > 0) {
      await updateViewSortableColumn({
        userId: Number(localStorage.getItem(localStorageItemNames.userID)),
        pageName: pageName,
        id: sortableColumnData[0]?.id,
        SortedColumn: columnId,
        Direction: sortingDirection ? sortingDirection : "",
        FleetDetails: JSON.stringify(sortedRows),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    } else {
      await createSortableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: pageName,
        SortedColumn: columnId,
        Direction: sortingDirection,
        FleetDetails: JSON.stringify(sortedRows),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    }
  }
};
